var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 5.625,
    fill: "#407BFF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_293_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7511 28.4318C25.0519 28.4318 23.391 27.928 21.9782 26.984C20.5654 26.04 19.4643 24.6983 18.8141 23.1285C18.1639 21.5587 17.9937 19.8314 18.3252 18.1649C18.6567 16.4984 19.4749 14.9677 20.6764 13.7662C21.8778 12.5648 23.4086 11.7466 25.0751 11.4151C26.7415 11.0836 28.4689 11.2537 30.0387 11.9039C31.6085 12.5542 32.9502 13.6553 33.8941 15.0681C34.8381 16.4808 35.342 18.1418 35.342 19.8409C35.3395 22.1186 34.4336 24.3023 32.823 25.9128C31.2124 27.5234 29.0288 28.4293 26.7511 28.4318ZM26.7511 14.1136C25.6183 14.1136 24.511 14.4495 23.5692 15.0789C22.6273 15.7082 21.8932 16.6027 21.4598 17.6492C21.0263 18.6957 20.9129 19.8473 21.1338 20.9582C21.3548 22.0692 21.9003 23.0897 22.7013 23.8907C23.5022 24.6917 24.5228 25.2372 25.6337 25.4581C26.7447 25.6791 27.8963 25.5657 28.9428 25.1322C29.9893 24.6987 30.8838 23.9647 31.5131 23.0228C32.1424 22.081 32.4783 20.9737 32.4783 19.8409C32.4766 18.3225 31.8727 16.8667 30.799 15.793C29.7253 14.7193 28.2695 14.1153 26.7511 14.1136Z",
    fill: "#4562EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0682 42.7514H12.4318C12.0521 42.7514 11.6879 42.6006 11.4194 42.3321C11.1509 42.0635 11 41.6993 11 41.3196C11.0031 38.6624 12.06 36.1148 13.939 34.2359C15.8179 32.3569 18.3655 31.2999 21.0227 31.2969H32.4773C35.1345 31.2999 37.6821 32.3569 39.561 34.2359C41.44 36.1148 42.4969 38.6624 42.5 41.3196C42.5 41.6993 42.3491 42.0635 42.0806 42.3321C41.8121 42.6006 41.4479 42.7514 41.0682 42.7514ZM14.0077 39.8878H39.4923C39.1602 38.2719 38.2811 36.82 37.0032 35.7767C35.7254 34.7334 34.1269 34.1626 32.4773 34.1605H21.0227C19.3731 34.1626 17.7746 34.7334 16.4968 35.7767C15.2189 36.82 14.3398 38.2719 14.0077 39.8878Z",
    fill: "#4562EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_293_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 31.5,
    fill: "white",
    transform: "translate(11 11.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.55400c1b5b9cbdb9add21c064e12d5c4.svg";
export { ForwardRef as ReactComponent };